<template>
    <div>
        <div class="ui secondary segment">
            <div class="ui equal width middle aligned grid reptest">
                <div class="left aligned column">
                    <span ref="pdf_progress">
                    </span>
                </div>
                <div class="right aligned column">
                    <button class="ui button" v-on:click="generateReport">
                        {{$t('components.report.pdf.button', { page_nr: page_nr } )}}
                    </button>
                </div>
            </div>
            <iframe ref="target_frame" id="canvas-target" style="
                display: none; 
                position: fixed; 
                overflow: scroll; 
                top: 0; 
                left: -9999; 
                z-index: -9000;
                height: 500px;
                width: 1400px;
                ">
            </iframe>
            <div id="showroom">
            </div>
        </div>
    </div>
</template>
<style scoped>
    #canvas-target {
        width: 1200px;
    }
</style>
<script>
// import VueHtml2pdf from 'vue-html2pdf'
import html2pdf from 'html2pdf.js'
// import html2canvas from 'html2canvas';

export default {
    methods: {
        /*
            Generate Report using refs and calling the
            refs function generatePdf()
        */
        async generateReport () {
            var target_frame = this.$refs.target_frame
            var canvas_target = target_frame.contentWindow.document.createElement('div')
            canvas_target.className = 'canvas_target'
            target_frame.contentWindow.document.body.appendChild(canvas_target)

            var delay = async (t, v) => {
                return new Promise(function (resolve) {
                    setTimeout(resolve.bind(null, v), t)
                });
            }

            var opt = {
                margin:       10,
                filename:     `${this.$attrs.project.scope.attributes.name}_${ new Date().toISOString().substring(0, 10) }.pdf`,
                image:        { type: 'jpeg', quality: 0.98 },
                pagebreak:    { 
                    mode:       'css',
                },
                html2canvas:  { 
                    scale: 4,
                    useCORS: true,
                    scrollX: -60,
                    scrollY: 0,
                    width: 1200,
                    // height: area.height,
                    windowWidth: 1400,
                    // windowHeight: area.height,
                },
                jsPDF:        { 
                    unit: 'mm', 
                    format: 'a4', 
                    orientation: 'portrait',
                    // contentWidth: 1200,
                    // width: 1200
                }
            };


            var fill_canvas_target = async (doc) => {
                canvas_target.innerHTML = doc.innerHTML

                await delay(1000)
                
                return canvas_target.cloneNode(true)
            }


            var pdf = html2pdf().set(opt)
            var page_cnt = 0;
            var progress_elem = this.$refs.pdf_progress

            var pages = []

            var buildings = document.querySelectorAll('section.building')

            buildings.forEach((building) => {
                var shafts = building.querySelectorAll('.shaft')
                shafts.forEach((shaft, j) => {
                    var building_copy = building.cloneNode(true)
                    var shafts_copy = building_copy.querySelectorAll('.shaft')
                    shafts_copy.forEach((shaft_copy, k) => {
                        if (
                            (j == 0 && k != 0) // first page
                            || (j != k && j + 1 != k) // 2 shafts/page thereafter
                            ) {
                            shaft_copy.parentElement.removeChild(shaft_copy)
                        }
                    })
                    if (j == 0) {
                        pages.push(building_copy)
                    }
                    if (j % 2 == 1) {
                        var savings = building_copy.querySelector(".savings")
                        savings.parentElement.removeChild(savings);
                        var building_data = building_copy.querySelector(".building-data")
                        building_data.parentElement.removeChild(building_data)
                        pages.push(building_copy)
                    }
                })
            })

            var savings = [
                document.getElementsByClassName('energy-savings').item(0),
                document.getElementsByClassName('money-savings').item(0),
                document.getElementsByClassName('carbon-savings').item(0),
            ];

            savings.forEach((saving) => {
                var saving_copy = saving.cloneNode(true)
                var close_button = saving_copy.querySelector(".chevron")
                close_button.parentElement.removeChild(close_button)
                pages.push(saving_copy)
            })

            pages.push()

            var setProgessText = (p) => {
                progress_elem.innerHTML = this.$t(
                    'components.report.pdf.progress', 
                    { page_nr: page_cnt, total_nr: pages.length+1 } 
                )
                page_cnt = page_cnt + 1
                return p
            }

            setProgessText(0)

            var first_page = document.getElementsByClassName('pdf-first-section').item(0)

            pdf = pdf.from(first_page).toContainer().toCanvas().toPdf().get('pdf')
                .then(setProgessText).then(p => p.addPage())

            for (var i in pages) {
                var current_page = await fill_canvas_target(pages[i]) ;
                // pdf = pdf.then(async () => { current_page = await fill_canvas_target(pages[i]) })
                pdf = pdf.from(current_page).toContainer().toCanvas().toPdf().get('pdf').then(setProgessText)
                if (i < pages.length-1) pdf = pdf.then(p => p.addPage())
            }
            await pdf.save()

            setTimeout(() => {
                progress_elem.innerHTML = ""
            }, 5000)
        },
        mounted() {
            this.$nextTick(() => {
            setTimeout(() => {
                this.$emit("domRendered");
            }, 1000);
            });
        },        
    },

    components: {
        // VueHtml2pdf
    },
}
</script>

<style lang="scss">
    .reset-css {
        all: initial;
        * {
            all: unset;
        }        
    }
</style>